
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { QuestionnaireModel } from 'models/generated/Entities.GormCrm.Questionnaire';
import { QuestionModel } from 'models/generated/Entities.GormCrm.Question';
import { QuestionnaireViewModel } from 'models/generated/Models.QuestionnaireView';
import { QuestionnaireQuestionReplyModel } from 'models/generated/Entities.GormCrm.QuestionnaireQuestionReply';


const _gormCrm_QuestionnaireControllerHelper = new Map<string, Object>();
_gormCrm_QuestionnaireControllerHelper.set('GetQuestionnaires', QuestionnaireModel);
_gormCrm_QuestionnaireControllerHelper.set('GetQuestionnaireById', QuestionnaireModel);
_gormCrm_QuestionnaireControllerHelper.set('GetQuestionnaireByTag', QuestionnaireModel);
_gormCrm_QuestionnaireControllerHelper.set('GetQuestionById', QuestionModel);
_gormCrm_QuestionnaireControllerHelper.set('GetQuestions', QuestionModel);
_gormCrm_QuestionnaireControllerHelper.set('SaveQuestion', QuestionModel);
_gormCrm_QuestionnaireControllerHelper.set('GetQuestionnaireView', QuestionnaireViewModel);
_gormCrm_QuestionnaireControllerHelper.set('GetQuestionnaireViewByTag', QuestionnaireViewModel);
_gormCrm_QuestionnaireControllerHelper.set('GetQuestionReply', QuestionnaireQuestionReplyModel);
_gormCrm_QuestionnaireControllerHelper.set('GetQuestionRepliesByTag', QuestionnaireQuestionReplyModel);


export const gormCrm_QuestionnaireControllerHelper = _gormCrm_QuestionnaireControllerHelper;

